import { defineVariants } from "@/runtime/style-engine/define-variants";

/**
 * Tailwind-like class variants for `<e-label>`.
 */
export const labelClasses = defineVariants({
  base: `
    e-label
    select-none
    font-semibold
    flex
    flex-col
    gap-1
  `,
  variants: {
    disabled: {
      true: "cursor-not-allowed opacity-60",
      false: "cursor-pointer",
    },
  },
  defaults: {
    disabled: false,
  },
});

/**
 * Classes for the label text wrapper.
 */
export const labelTextClasses = "e-label-text";

/**
 * Classes for the label description text.
 */
export const labelDescriptionClasses = `
  e-label-description
  text-xs
  text-(--color-elevation-600)
`;
